export default __webpack_public_path__ + "static/media/daniel.dadb23a2.png";